// extracted by mini-css-extract-plugin
export default {"titleWrapper":"zevX6","titleWrapperInFeed":"tpVN3","title":"EKHsv"};